import {TmcService} from "../../service/TmcService";
import {TmcDefinition} from "../../models/TmcDefinition";
import {IModalService, IModalSettings} from "angular-ui-bootstrap";
import {TmcList} from "../component/TmcListComponent";
import {AccountId} from "../../../account/types/AccountRecord";
import {OptionContractsCache} from "../../../options/contracts/cache/OptionContractsCache";

export class TmcListDialog {

    public static readonly id = "tmcListDialog";

    /** @ngInject */
    public constructor(private readonly tmcService: TmcService,
                       private readonly optionContractsCache: OptionContractsCache,
                       private readonly $uibModal: IModalService) {
    }

    public async open(accountId: AccountId): Promise<TmcDefinition> {
        const options: IModalSettings = {
            component: TmcList,
            resolve: {
                tmcs: () => this.tmcService.current(accountId).catch(() => []),
                options: () => this.optionContractsCache.all().catch(() => [])
            }
        };
        const instance = this.$uibModal.open(options);
        return instance.result;
    }
}
